import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser, faSearch, faSun, faMoon, faExpand, faCompress, faHouse, faShareNodes,
    faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../context/LanguageContext";
import wabysLogo from '../assets/wabys.png';
import watomsLogo from '../assets/watoms3.png';
import fullScreen from '../utils/fullScreen';
import useFullScreen from "../hooks/useFullScreen";
// images
import wisdomLogo from '../assets/wisdom.png';
import { useAuth } from "context/AuthContext";

const NeqatyNavbar = ({ system = "watoms", children }) => {
    const { userInfo, logout } = useAuth();
    const navigate = useNavigate();
    const { language } = useLanguage();
    const isFullScreen = useFullScreen();

    return (
        <div className="relative z-10">
            {/* Logo and Search */}
            <div className="min-h-[11vh] md:h-[11vh] h-fit flex flex-col md:flex-row items-center justify-between w-full max-w-7xl mx-auto px-6 py-5 gap-8">
                <div className="flex items-center gap-6">
                    <img className="w-[100px] md:w-[120px] lg:w-[140px] cursor-pointer" src={wabysLogo} alt="Wabys Logo" onClick={() => navigate('/wabys')} />
                    <div className='border-l-2 border-gray-500 p-1 h-8' />
                    <img className="w-[90px] md:w-[100px] lg:w-[100px] cursor-pointer" src={system === "watoms" ? watomsLogo : wisdomLogo} alt="Wabys Logo" onClick={() => navigate('/watoms')} />
                </div>
                <div className="flex items-center gap-4 relative flex-wrap justify-evenly">
                    {children}
                    {/* <button onClick={() => setDarkMode(!darkMode)} className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all">
                        <FontAwesomeIcon icon={darkMode ? faSun : faMoon} className="text-xl text-watomsBlue" />
                    </button> */}
                    {/* Full Screen Toggle Button */}
                    <button
                        onClick={fullScreen}
                        className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
                        title={language ? (isFullScreen ? 'Exit Full Screen' : 'Enter Full Screen') : (isFullScreen ? 'خروج من الشاشة الكاملة' : 'دخول الشاشة الكاملة')}
                    >
                        <FontAwesomeIcon
                            icon={isFullScreen ? faCompress : faExpand}
                            className="text-xl text-watomsBlue"
                        />
                    </button>
                    {/* User Info */}
                    <span className="flex items-center gap-2 font-bold text-lg md:min-w-[120px] min-w-[300px] justify-center">
                        <FontAwesomeIcon icon={faUser} className="text-watomsBlue" />
                        {userInfo?.name}
                    </span>
                    {/* Share Button */}
                    <button
                        className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
                    >
                        <FontAwesomeIcon icon={faShareNodes} className="text-xl text-gray-500" />
                    </button>
                    {/* Logout / Home Button */}
                    <button
                        className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
                        onClick={logout}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} className="text-xl text-wisdomOrange" />
                    </button>
                    {/* <button
                        className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
                        onClick={() => navigate('/neqaty')}
                    >
                        <FontAwesomeIcon icon={faHouse} className="text-xl text-green-700" />
                    </button> */}
                </div>
            </div>
        </div>
    );
}

export default NeqatyNavbar;